import React, { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import "bootstrap/dist/css/bootstrap.min.css"; 
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; 
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; 
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx'; 
import Header from '../Header';

const UserTicket = () => {

  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
  const tableRef = useRef(null);
  const id = localStorage.getItem('userId');
    const navigate = useNavigate();
  

  // Fetch tickets data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/usertickets/${id}`);
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const result = await response.json();  
        setTickets(result.data || []);  
        console.log(result);
      } catch (error) {
        console.error("Error fetching data:", error); 
        setError(error.message);  
      } finally {
        setLoading(false);  
      }
    };

    fetchData(); 
  }, []);

  // Initialize DataTable after tickets data is fetched
  useEffect(() => {
    if (tickets.length > 0 && tableRef.current) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true, 
        paging: true,
        pageLength: 10, 
        lengthMenu: [10, 25, 50, 100], 
        columnDefs: [
          { targets: 0, responsivePriority: 1 },
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
          { targets: 3, responsivePriority: 4 },
          { targets: 4, responsivePriority: 5 },
        ],
      });

      return () => {
        table.destroy(); // Cleanup on unmount
      };
    }
  }, [tickets]);

  const exportToExcel = () => {
    if (tickets.length === 0) {
      alert("No data to export");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(tickets);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "tickets");

    XLSX.writeFile(wb, "Tickets_List.xlsx");
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
     <Header />
    
    <div className="shadow mx-1 px-3 bg-light rounded-3">
      <div className="d-flex align-items-center justify-content-between p-3 mt-3">
        <h4 className="mb-0">All Tickets</h4>
        <button className="btn btn-success" onClick={exportToExcel}>
          Export to Excel
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="card">
        <div className="card-header">Tickets List</div>
        <div className="card-body">
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-striped table-bordered display nowrap"
              style={{ width: '100%' }}
            >
              <thead>
                <tr>
                  <th>S.no</th>
                  <th>Ticket Id</th> 
                  <th>Subject</th>
                  <th>Description</th>
                  <th>File</th>
                  <th>Remaks</th>
                  <th>Document</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {tickets.length > 0 ? (
                  tickets.map((tickets, index) => (
                    <tr key={tickets.id}>
                      <td>{index + 1}</td>
                      <td className="text-danger">{tickets.ticket_id || 'N/A'}</td>
                      <td>{tickets.Subject || 'N/A'}</td>
                      <td>{tickets.Description || 'N/A'}</td>
                      <td>
                      {tickets.file ? (
                        <a href={`https://apiaksharaconnect.aksharafinalytics.in/ticket_files/${tickets.file}`} download={tickets.file || 'N/A'} target='_blank'>
                        <button className="btn btn-warning ms-2 p-1 m-1"><FontAwesomeIcon icon={faDownload} /> Download</button>
                        </a>
                        ) : (
                            <span>No file available</span>  // Fallback message if no file exists
                          )}
                      </td>
                      <td>{tickets.emp_Description || 'N/A'}</td>
                      <td>
                        {tickets.emp_file ? (
                          <a href={`https://apiaksharaconnect.aksharafinalytics.in/${tickets.emp_file}`} download={tickets.emp_file || 'N/A'} target='_blank'>
                          <button className="btn btn-warning ms-2 p-1 m-1"><FontAwesomeIcon icon={faDownload} /> Download</button>
                          </a>
                          ) : (
                              <span>N/A</span>  // Fallback message if no file exists
                        )}
                      </td>
                      <td>{tickets.status || 'N/A'}</td>
                      <td>{tickets.doa || 'N/A'}</td>
                      <td>
                        <button className="btn btn-primary" onClick={() => navigate(`/TicketQueries/${tickets.ticket_id}`)}>
                            View
                        </button>
                      </td>  
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className='text-center'>No Tickets available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default UserTicket;
